import { Observable } from 'rxjs';
import { BuildConfig } from './build.config.types';

export interface ConfigAdapter {
  getConfig(): Partial<BuildConfig> | Observable<Partial<BuildConfig>>;
}
